module.exports = __webpack_public_path__ + "static/media/background.390a91b9.jpg";